module.exports = __webpack_public_path__ + "img/bedroom-beds-headboards.5484120.jpg";